import { render } from "./TheFleetVehicles.vue?vue&type=template&id=285b95c6"
import script from "./TheFleetVehicles.vue?vue&type=script&lang=js"
export * from "./TheFleetVehicles.vue?vue&type=script&lang=js"

import exportComponent from "/workspace/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__